import GiftReceipt from '../../../components/gift-receipt/GiftReceipt';

const GIFT_RECEIPT_CHECKBOX = {
  component: GiftReceipt,
  type: 'checkbox',
  id: 'giftReceipt',
  name: 'giftReceipt',
  label: 'Yes, this order is a gift (Prices will not be shown on the delivery note)',
  checkedValue: 'true',
};

export default GIFT_RECEIPT_CHECKBOX;
